import { useState, useEffect } from "react";
import moment from "moment";
import InputSelect from "../../../../../../../shared/components/inputs/InputSelect/InputSelect";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useLoading } from "../../../../../../../shared/context/LoadingContext";
import toast from "react-hot-toast";

import InputNumber from "../../../../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../../../../shared/components/inputs/InputText/InputText";

import "./ModalEntradaDebito.scss";

const formasPagamento = [
  "Dinheiro",
  "Cheque",
  "Internet banking",
  "Cartão de crédito",
];

function ModalReceberEntradaDebito({
  openModalReceberEntrada,
  handleCloseModalReceberEntrada,
  sendRequest,
  updateEntradas,
  auth,
  clinicaId,
  emitirDocEletronicoEntradas,
  cliente,
  entrada,
  modoContingenciaAtivo,
}) {
  const { startLoading, stopLoading } = useLoading();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(openModalReceberEntrada);
  const [metodoPagamento, setMetodoPagamento] = useState(formasPagamento[0]);
  const [dataPagamento, setDataPagamento] = useState(moment());
  const [caixa, setCaixa] = useState(
    entrada.caixa._id ? entrada.caixa._id : entrada.caixa.id,
  );

  const [categorias, setCategorias] = useState();
  const [categoria, setCategoria] = useState(entrada.categoria._id);
  const [caixas, setCaixas] = useState([]);
  const [permCaixas, setPermCaixas] = useState([]);

  // Adicionar estados para o diálogo de confirmação
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [pendingEmit, setPendingEmit] = useState(null);

  //CHEQUE DADOS
  const [numero, setNumero] = useState("");
  const [banco, setBanco] = useState("");
  const [dataCheque, setDataCheque] = useState(moment());
  const [nrConta, setNrConta] = useState("");

  const numeroChangeHandler = (value) => {
    setNumero(value);
  };

  const contaClienteChangeHandler = (value) => {
    setNrConta(value);
  };

  const bancoChangeHandler = (value) => {
    setBanco(value);
  };

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [caixasResponse, categoriasResponse] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinicaId}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/entrada/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
        ]);

        const caixasFormatted = caixasResponse.caixas.map((cai) => ({
          id: cai.id,
          value: cai.caixa,
        }));

        const caixaClinica = caixasFormatted.filter(
          (c) => c.value === "Clínica",
        );

        // Process categorias
        const categoriasFormatted = categoriasResponse.categoriasFinanceiro.map(
          (cat) => ({
            id: cat.id,
            value: cat.categoria,
          }),
        );

        const isCategoriaActive = categoriasFormatted.find(
          (catF) => catF.id === entrada.categoria._id,
        );
        if (!isCategoriaActive) {
          categoriasFormatted.push({
            id: entrada.categoria._id,
            value: entrada.categoria.categoria,
          });
        }

        setCategorias(categoriasFormatted);
        setCategoria(
          entrada.categoria._id
            ? entrada.categoria._id
            : categoriasFormatted[0]?.id,
        );

        setCaixas(caixaClinica);
        setCaixa(caixaClinica[0].id);
        setPermCaixas(caixasFormatted);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchData();
  }, [auth.token, clinicaId, sendRequest]);

  useEffect(() => {
    setOpenModal(openModalReceberEntrada);
  }, [openModalReceberEntrada]);

  const metodoPagamentoChangeHandler = (valor) => {
    setMetodoPagamento(valor);
    if (valor === "Dinheiro") {
      const caixaClinica = permCaixas.filter((c) => c.value === "Clínica");
      setCaixas(caixaClinica);
      setCaixa(caixaClinica[0].id);
    } else {
      const caixasSemClinica = permCaixas.filter((c) => c.value !== "Clínica");
      const caixaClinica = permCaixas.find((c) => c.value === "Clínica");
      setCaixas(caixasSemClinica);
      if (caixa === caixaClinica.id) setCaixa(caixasSemClinica[0].id);
    }
  };

  const receberEntradaHandler = async (emit) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("dataPagamento", dataPagamento);
      formData.append("metodoPagamento", metodoPagamento);
      formData.append("recebidoPor", auth.userId);
      formData.append("caixa", caixa);
      formData.append(
        "caixaExtenso",
        caixas.find((cx) => cx.id === caixa).value,
      );

      if (metodoPagamento === "Cheque") {
        //DADOS CHEQUE
        formData.append("banco", banco);
        formData.append("dataCheque", dataCheque);
        formData.append("nrCheque", numero);
        formData.append("nrContaCliente", nrConta);
      }

      if (categoria) {
        formData.append("categoria", categoria);
      }

      //LEMBRA DE ADICIONAR COMPROVATIVO MAIS TARDE
      let entradaAtualizada;
      try {
        entradaAtualizada = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/receber/${entrada._id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
      } catch (err) {
        console.error("err", err);
      }

      if (emit) {
        emitirDocEletronicoEntradas(
          entradaAtualizada.entrada,
          null,
          "FRE",
          "atualizar",
        );
      } else {
        toast.success("Entrada recebida com sucesso!");
        updateEntradas(entradaAtualizada.entrada, "atualizar");
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsSubmitting(false);
      handleCloseModalReceberEntrada();
    }
  };

  const preReceberEntradaHandler = (e, emit) => {
    if (!dataPagamento) {
      toast.error("Introduza a data de recebimento");
    } else if (!moment.isMoment(dataPagamento) || !dataPagamento.isValid()) {
      toast.error("Introduza a data de recebimento corretamente");
    } else if (!isSubmitting) {
      if (emit && cliente?.nome !== cliente?.nomeFiscal) {
        // Guardar a operação pendente e mostrar o diálogo
        setPendingEmit(emit);
        setConfirmDialogOpen(true);
      } else {
        // Prosseguir normalmente
        setIsSubmitting(true);
        receberEntradaHandler(emit);
      }
    }
  };

  // Handlers para o diálogo
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
    setPendingEmit(null);
  };

  const handleConfirmDialogConfirm = () => {
    setConfirmDialogOpen(false);

    // Executar a operação pendente
    if (pendingEmit) {
      setIsSubmitting(true);
      receberEntradaHandler(pendingEmit);
    }

    setPendingEmit(null);
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalReceberEntrada}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box adicionar-entrada__modal"
          id="modal__adicionar-entrada"
        >
          <h1 className="fluxo-atendimento__modal__titulo">
            Receber entrada - {entrada.descricao}
          </h1>
          {/* {entrada && ( */}
          <div className="adicionar-entrada__modal__container">
            <div className="customInputContainer adicionar-despesa__modal__container--span2">
              <input
                type="text"
                defaultValue={entrada.descricao}
                className="customInput inputNumber"
                id="descricao"
                style={{ pointerEvents: "none", color: "#88959e" }}
                readOnly
              />
              <label className="customInputLabel" htmlFor="descricao">
                Descrição
              </label>
            </div>

            <div className="customInputContainer adicionar-despesa__modal__container--span1">
              <input
                type="text"
                defaultValue={entrada.valor}
                className="customInput inputNumber"
                id="valor"
                style={{ pointerEvents: "none", color: "#88959e" }}
                readOnly
              />
              <label className="customInputLabel" htmlFor="valor">
                Valor
              </label>
            </div>

            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-despesa__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data do Pagamento*"
                inputFormat="DD-MM-YYYY"
                value={dataPagamento}
                onChange={(value) => setDataPagamento(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            {categorias && categoria && (
              <div className="customInputContainer adicionar-entrada__modal__container--span2">
                <select
                  onChange={(e) => setCategoria(e.target.value)}
                  className="customInputSelect"
                  value={categoria}
                >
                  {categorias &&
                    categoria &&
                    categorias.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Categoria</label>
              </div>
            )}

            <div className="customInputContainer adicionar-despesa__modal__container--span2">
              <input
                type="text"
                defaultValue={cliente?.nome}
                className="customInput inputNumber"
                id="cliente"
                style={{ pointerEvents: "none", color: "#88959e" }}
                readOnly
              />
              <label className="customInputLabel" htmlFor="cliente">
                Cliente
              </label>
            </div>

            <textarea
              cols="30"
              rows="7"
              placeholder="observacao"
              value={entrada.observacao}
              readOnly
              className="adicionar-entrada__modal__container__textarea"
              style={{ color: "#88959e" }}
            ></textarea>
          </div>

          <div
            className="adicionar-despesa__modal__pagamento"
            style={{ marginTop: 25, marginBottom: 25 }}
          >
            <InputSelect
              className="adicionar-entrada__modal__container--span1"
              label="Forma de pagamento"
              initialValue={metodoPagamento}
              handleChange={metodoPagamentoChangeHandler}
              items={formasPagamento}
            />

            {caixas && caixa && (
              <div className="customInputContainer adicionar-entrada__modal__container--span1">
                <select
                  onChange={(e) => setCaixa(e.target.value)}
                  className="customInputSelect"
                  value={caixa}
                >
                  {caixas &&
                    caixa &&
                    caixas.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Caixa</label>
              </div>
            )}
          </div>

          {metodoPagamento === "Cheque" && (
            <div className="modalEntrada__dadosCheque">
              <InputNumber
                key="numeroCheque"
                id="numeroCheque"
                initialValue={0}
                label="Número Cheque*"
                handleChange={numeroChangeHandler}
              />

              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  className="valorDataCaixa__fields--field muiDatePicker"
                  label="Data*"
                  inputFormat="DD-MM-YYYY"
                  value={dataCheque}
                  onChange={(value) => setDataCheque(value)}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>

              <InputText
                initialValue={nrConta}
                label="Conta do cliente*"
                handleChange={contaClienteChangeHandler}
                notEmpty={true}
                id="contaDoCliente"
              />
              <InputText
                initialValue={banco}
                label="Banco*"
                handleChange={bancoChangeHandler}
                notEmpty={true}
                id="banco"
              />
            </div>
          )}

          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalReceberEntrada}
              style={{ display: "block" }}
            >
              Fechar
            </span>

            <span
              disabled={isSubmitting}
              className="blue-button"
              onClick={preReceberEntradaHandler}
            >
              {isSubmitting ? "Recebendo..." : "Receber"}
            </span>

            {/*Emitir FRE*/}
            {!entrada.documentoEletronico && (
              <span
                disabled={isSubmitting}
                className={isSubmitting ? "cancel-btn" : "blue-button"}
                onClick={preReceberEntradaHandler.bind(null, null, "emitirFRE")}
              >
                {isSubmitting
                  ? "Recebendo e emitindo FRE..."
                  : `Receber e emitir FRE ${
                      modoContingenciaAtivo ? " (Contingência)" : ""
                    }`}
              </span>
            )}
          </div>
        </Box>
      </Modal>

      {/* Dialog de confirmação */}
      <Dialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          Atenção: Nomes diferentes
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            O nome do cliente ({cliente?.nome}) e o nome fiscal (
            {cliente?.nomeFiscal}) são diferentes. Deseja prosseguir com a
            emissão do documento?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDialogConfirm}
            color="primary"
            autoFocus
          >
            Prosseguir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ModalReceberEntradaDebito;
